module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header__title"
  }, [_vm._v("SHIN ANDO")]), _vm._v(" "), _c('div', {
    staticClass: "header__nav"
  }, [_c('a', {
    staticClass: "header__nav__link",
    attrs: {
      "href": "/#/about"
    }
  }, [_vm._v("ABOUT")]), _vm._v(" "), _c('a', {
    staticClass: "header__nav__link",
    attrs: {
      "href": "/#/works"
    }
  }, [_vm._v("WORKS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df80271"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 21
// module chunks = 0